import React from 'react'
import { CobranzaProvider } from './CobranzaContext'
// import GestionAtencionCobro from '../elements/components/gestion-atencion-cobro/GestionAtencionCobro'
import GestionAtencionCobro from '../../project/components/gestion-atencion-cobro/GestionAtencionCobro'

const GestionAtencionCobroProvided = () => {
  return (
    <CobranzaProvider>
      <GestionAtencionCobro />
    </CobranzaProvider>
  )
}

export default GestionAtencionCobroProvided